import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { Copy } from 'lucide-react';
import apiClient from '../api/client';

export default function ShowPasswordModal({ user, domain, onClose }) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchPassword = async () => {
      setLoading(true);
      try {
        const res = await apiClient.post(`/api/users/contact-details`, {
          domain,
          userId: user.szUserId,
          companyId: user.szCompanyId,
        });
        setDetails(res.data);
      } catch (err) {
        toast.error("Failed to load password details");
        onClose();
      } finally {
        setLoading(false);
      }
    };
    fetchPassword();
  }, [user, domain, token, onClose]);

  const CopyField = ({ label, value }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
      if (!value) return;

      navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success(`${label} copied!`);
      setTimeout(() => setCopied(false), 2000);
    };

    return (
      <div>
        <div style={{ fontSize: '10px', fontWeight: 600, color: '#495057', marginBottom: '5px' }}>
          {label}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{ 
            flex: 1, 
            fontSize: '13px', 
            padding: '8px 12px', 
            background: '#f8f9fa', 
            border: '1px solid #dee2e6', 
            borderRadius: '6px',
            fontFamily: 'monospace',
            wordBreak: 'break-all'
          }}>
            {value || '—'}
          </div>
          <button
            onClick={handleCopy}
            style={{
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #0aa375',
              background: copied ? '#0aa375' : '#fff',
              color: copied ? '#fff' : '#0aa375',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            <Copy size={18} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 1060,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px'
    }} onClick={onClose}>
      
      <div style={{
        width: '100%', maxWidth: '460px', background: 'white', borderRadius: '10px',
        overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>

        <div style={{ 
          background: '#0aa375', color: 'white', padding: '12px 18px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: '15.5px' }}>Show Password</div>
              <div style={{ fontSize: '13px', marginTop: '2px' }}>
                {user.szUserName} | {user.szCompanyName}
              </div>
            </div>
            <button 
              onClick={onClose} 
              style={{ fontSize: '28px', background: 'none', border: 'none', color: 'white' }}
            >
              ×
            </button>
          </div>
          <div style={{ fontSize: '11px', opacity: 0.85, marginTop: '4px' }}>
            UID: {user.szUserId} | CID: {user.szCompanyId}
          </div>
        </div>

        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success spinner-border-sm" />
              <p style={{ marginTop: '12px' }}>Loading...</p>
            </div>
          ) : details ? (
            <>
              <CopyField label="USERNAME" value={details.userName} />
              <CopyField label="PASSWORD" value={details.plainPassword} />
              <div>
                <div style={{ fontSize: '10px', fontWeight: 600, color: '#495057', marginBottom: '5px' }}>ENCRYPTED PASSWORD</div>
                <div style={{ 
                  padding: '8px 12px', 
                  background: '#f8f9fa', 
                  border: '1px solid #dee2e6', 
                  borderRadius: '6px',
                  fontSize: '13px', 
                  fontFamily: 'monospace',
                  wordBreak: 'break-all'
                }}>
                  {details.encryptedPassword || '—'}
                </div>
              </div>
            </>
          ) : (
            <p style={{ textAlign: 'center', color: '#dc3545' }}>No password details available</p>
          )}
        </div>

        <div style={{ padding: '12px 18px', borderTop: '1px solid #eee', background: '#f8f9fa', textAlign: 'right' }}>
          <button 
            onClick={onClose}
            style={{ 
              padding: '7px 22px', background: '#6c757d', color: 'white', 
              border: 'none', borderRadius: '6px', fontSize: '13px'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}